import React from "react";

import { ApolloProvider } from "@apollo/client";
import { NELProvider } from "@nel-ui/react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { CommonError, Layout } from "./components";
import { ERROR_MESSAGE } from "./constants";
import { getEnvConfig } from "./context/api";
import { AppProvider } from "./context/appProvider";
import client from "./graph/client";
import "./style.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Get environment file based on the hostname
const getEnvironment = async () => {
  const hostname = window.location.hostname;
  if (hostname.includes("dev")) return ".dev";
  if (hostname.includes("test")) return ".test";
  if (hostname.includes("prod")) return ".prod";
  return ".prod";
};

const init = async () => {
  // @TODO: This is temporary solution to get the specific environment configuration and will be handle in #DIGI-23105
  const env = await getEnvironment();
  await getEnvConfig(env);

  root.render(
    <React.StrictMode>
      <NELProvider>
        {window.configuration?.IB_URL ? (
          <ApolloProvider client={client()}>
            <AppProvider>
              <App />
            </AppProvider>
          </ApolloProvider>
        ) : (
          <Layout>
            <CommonError
              heading={ERROR_MESSAGE.HEADING}
              subHeading={ERROR_MESSAGE.SUB_HEADING}
            />
          </Layout>
        )}
      </NELProvider>
    </React.StrictMode>
  );
};

void init();
